module.exports = __webpack_public_path__ + "img/goldregen-2020-087.86d63cff.jpg";